export default function getStockedMessage(vendorOption: VendorOptionState): StockedState {
  if (vendorOption?.isBackordered) {
    return StockedState.BACKORDERED;
  } else if (vendorOption?.shippingTime >= 6) {
    return StockedState.LONG_HANDLING_TIME;
  } else if (vendorOption?.isFulfillmentPolicyStock === true && vendorOption?.shippingTime <= 3) {
    return StockedState.STOCKED;
  } else {
    return StockedState.UNKNOWN;
  }
}

export enum StockedState {
  LONG_HANDLING_TIME = "Long Handling Time",
  STOCKED = "Stocked",
  BACKORDERED = "Backordered",
  UNKNOWN = "null",
}
